<template>
  <div class="editor-time bg-white" style="padding-bottom: 40px;">
    <div ref="flatpickr">
      <input
        v-model="time"
        data-input
        hidden
      />
    </div>
    <div class="position-absolute" style="right: 0; bottom: 0; padding: 0 20px 10px 0;">
      <base-button @click="save()" size="sm" type="success" icon="fa fa-check">
        Ok
      </base-button>
    </div>
  </div>
</template>

<script>
import flatpickr from "flatpickr";
import moment from "moment";
export default {
  data() {
    return {
      time: null,
    };
  },
  mounted() {
    this.picker = flatpickr(this.$refs.flatpickr, {
      dateFormat: 'H:i',
      enableTime: true,  
      time_24hr: true, 
      noCalendar: true, 
      minuteIncrement: 10,
      clickOpens: false,
      wrap: true,
      inline: true,
      defaultHour: moment(this.params.value, 'HH:mm').format('HH'),
      defaultMinute: moment(this.params.value, 'HH:mm').format('mm'),
    });
  },
  methods: {
    getValue() {
      return this.time;
    },
    isPopup() {
      return true;
    },
    save() {
      this.params.stopEditing();
    },
  },
};
</script>

<style>
.editor-time {
  .flatpickr-calendar.inline{
    top: 0 !important;
    box-shadow: none !important;
    border: none !important;
    border-radius: 0 !important;
  }
}
</style>